import {
  GET_CONFIG,
  GET_CONFIG_SUCCESS,
  GET_CONFIG_FAILURE,
  GET_CONFIG_SYS,
  GET_CONFIG_SYS_SUCCESS,
  GET_CONFIG_SYS_FAILURE,
  GET_CONFIG_SYS_LOAI_TAI_SAN,
  GET_CONFIG_SYS_LOAI_TAI_SAN_SUCCESS,
  GET_CONFIG_SYS_LOAI_TAI_SAN_FAILURE,
} from "actions/CauHinh/actionTypes";

const initialState = {
  getConfigLoading: false,
  objConfig: {},
  objConfigSys: {},
  objConfigSysLoaiTS: {},
  objConfigSysLoaiTSLoaded: false,
};

const getConfig = (state, action) => ({
  ...state,
  getConfigLoading: true,
});

const getConfigSuccess = (state, action) => {
  return {
    ...state,
    getConfigLoading: false,
    objConfig: action.payload,
  };
};

const getConfigFailed = (state, action) => ({
  ...state,
  getConfigLoading: false,
  objConfig: {},
});

const getConfigSys = (state, action) => ({
  ...state,
});

const getConfigSysSuccess = (state, action) => {
  return {
    ...state,
    objConfigSys: action.payload,
  };
};

const getConfigSysFailed = (state, action) => ({
  ...state,
  objConfigSys: {},
});
const getConfigSy_LoaiTaiSan = (state, action) => ({
  ...state,
  objConfigSysLoaiTSLoaded: true,
});

const getConfigSy_LoaiTaiSanSuccess = (state, action) => {
  return {
    ...state,
    objConfigSysLoaiTS: action.payload,
    objConfigSysLoaiTSLoaded: true,
  };
};

const getConfigSy_LoaiTaiSanFailed = (state, action) => ({
  ...state,
  objConfigSysLoaiTS: {},
  objConfigSysLoaiTSLoaded: true,
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFIG:
      return getConfig(state, action);
    case GET_CONFIG_SUCCESS:
      return getConfigSuccess(state, action);
    case GET_CONFIG_FAILURE:
      return getConfigFailed(state, action);
    case GET_CONFIG_SYS:
      return getConfigSys(state, action);
    case GET_CONFIG_SYS_SUCCESS:
      return getConfigSysSuccess(state, action);
    case GET_CONFIG_SYS_FAILURE:
      return getConfigSysFailed(state, action);
    case GET_CONFIG_SYS_LOAI_TAI_SAN:
      return getConfigSy_LoaiTaiSan(state, action);
    case GET_CONFIG_SYS_LOAI_TAI_SAN_SUCCESS:
      return getConfigSy_LoaiTaiSanSuccess(state, action);
    case GET_CONFIG_SYS_LOAI_TAI_SAN_FAILURE:
      return getConfigSy_LoaiTaiSanFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
